<template>
	<app-dropdown
		v-if="depots"
		v-model="val"
		align="right"
		label-key="name"
		value-key="code"
		:size="size"
		:options="depots"
		:v-model="modelValue"
		:multiple="multiple"
		:disabled="disabled"
		@update:model-value="updateValue">
		ALL DEPOTS
	</app-dropdown>

	<app-loader v-else />
</template>

<script lang="ts" setup>
	import { ref, onMounted } from 'vue'
	import DepotService from '@/services/depot'
	import useAuthStore from '@/stores/auth'
	import type { Depot } from '@/data/schema/depot'

	const auth = useAuthStore()
	const depot = new DepotService()
	const depots = ref()
	const val = ref()

	const props = withDefaults(
		defineProps<{
			modelValue?: string | string[] | undefined
			multiple?: boolean
			updateUser?: boolean
			disabled?: boolean
			allDepots?: boolean
			size?: string
		}>(),
		{
			modelValue: undefined,
			updateUser: false,
			multiple: false,
			disabled: false,
			allDepots: false,
			size: 'medium'
		}
	)

	const emit = defineEmits(['update:modelValue'])
	function updateValue(value: string | string[]) {
		val.value = value

		if (props.updateUser) {
			auth.setDepot(val.value)
		}

		emit('update:modelValue', value)
	}

	onMounted(() => {
		depot
			.getAll({}, props.allDepots ? undefined : auth.user?.assigned_depots)
			.then((res) => {
				if (res.data.data.length > 1) {
					depots.value = res.data.data.sort((a: Depot, b: Depot) =>
						a.name.localeCompare(b.name)
					)
				} else {
					depots.value = [res.data.data]
				}

				val.value = props.modelValue
			})
			.catch((error) => {
				console.error(error)
			})
	})
</script>
